import { c as _c } from "react-compiler-runtime";
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { SortTableAscIcon } from 'foundations-assets/icons/components/SortTableAscIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollToTopWrapper = styled.div.withConfig({
  displayName: "ScrollToTopButton__ScrollToTopWrapper"
})(["position:absolute;inset-block-end:16px;inset-inline-end:16px;z-index:5;"]);
const ScrollToTopButton = t0 => {
  const $ = _c(4);
  const {
    onClick,
    visible
  } = t0;
  if (!visible) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(SortTableAscIcon, {});
    t2 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.pagination.backToTop"
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = /*#__PURE__*/_jsx(ScrollToTopWrapper, {
      "data-test-id": "scroll-to-top-button",
      children: /*#__PURE__*/_jsxs(Button, {
        use: "tertiary-on-fill",
        size: "medium",
        onClick: onClick,
        borderRadius: "400",
        children: [t1, t2]
      })
    });
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ScrollToTopButton;